import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Controller, } from "react-hook-form";
import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import { colCenter } from "@ui/style/style";
import { Icon } from "@iconify/react";
export const STabInput = forwardRef(({ control, name, label, defaultValue = [], rules, options, variant, color = "success" }, ref) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("md"));
    return (_jsxs(Box, { sx: {
            background: "#919EAB14",
            borderRadius: 1.5,
            px: 1.5,
            py: "6.5px",
        }, children: [_jsx(Typography, { variant: "caption", color: "text.secondary", children: label }), _jsx(Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    mt: 0.5,
                }, children: _jsx(Controller, { name: name, control: control, defaultValue: defaultValue, rules: rules, render: ({ field }) => (_jsx(Box, { sx: {
                            ...colCenter,
                            flexDirection: isSm ? "column" : "row",
                            mt: 0.5,
                        }, children: options.map((option, index) => {
                            const isFirst = index === 0;
                            const isLast = index === options.length - 1;
                            const isMiddle = !isFirst && !isLast;
                            const isSelected = field.value.includes(option.value);
                            return (_jsx(Button, { onClick: () => {
                                    if (isSelected) {
                                        // Deselect option if it's already selected
                                        field.onChange(field.value.filter((v) => v !== option.value));
                                    }
                                    else {
                                        // Select option if it's not already selected
                                        field.onChange([...field.value, option.value]);
                                    }
                                }, fullWidth: true, startIcon: isSelected ? (_jsx(Icon, { icon: "eva:checkmark-outline", width: "20", height: "20" })) : undefined, variant: isSelected ? "contained" : "soft", color: color, sx: {
                                    ...(isFirst && {
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                    }),
                                    ...(isLast && {
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                    }),
                                    ...(isMiddle && {
                                        borderRadius: 0,
                                    }),
                                }, children: option.label }, index));
                        }) })) }) })] }));
});
